import { useCallback, useEffect, useState } from "react";
//old import { useSearchParams } from "react-router-dom";
import { Link, useSearchParams } from "react-router-dom";
//old import { Layers, Plus, Copy, Check, Link2, RefreshCw, ArrowLeft, Pencil, Archive, Loader2, ClipboardList, FileText, Mic, Users } from "lucide-react";
import { Layers, Plus, Copy, Check, Link2, RefreshCw, ArrowLeft, Pencil, Archive, Loader2, ClipboardList, FileText, Mic, Users, BookOpen } from "lucide-react";
import api from "../../api/api";
import {
    Alert, EmptyState, Field, OrgModal, Panel, Pill, apiError, formatDate, useOrgStyles,
} from "../../components/org/orgUi";
import InlineTableSkeleton from "../../components/layout/InlineTableSkeleton";
import { useOrgPortal } from "./orgPortalContext";
//old import ProgramCohorts from "./ProgramCohorts";
//old import ProgramCohorts, { ResourceEditor, ResourceList } from "./ProgramCohorts";
import ProgramCohorts, { ProgramSuggestions, ResourceEditor, ResourceList } from "./ProgramCohorts";

export default function OrgPrograms() {
    //old const { orgId, org, isOrgAdmin, reloadOrg, goTo } = useOrgPortal();
    const { orgId, org, isOrgAdmin, isPlatformAdmin, reloadOrg, goTo } = useOrgPortal();
    const s = useOrgStyles();
    const [searchParams, setSearchParams] = useSearchParams();
    const [programs, setPrograms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [editing, setEditing] = useState(null); // null | {} (new) | program
    const selectedId = Number(searchParams.get("programId")) || null;

    const load = useCallback(async () => {
        try {
            const res = await api.get(`/org/${orgId}/programs`);
            setPrograms(res.data.programs || []);
        } catch (err) {
            setError(apiError(err, "Couldn't load programs."));
        } finally {
            setLoading(false);
        }
    }, [orgId]);

    useEffect(() => { load(); }, [load]);

    const select = (id) => {
        const next = new URLSearchParams(searchParams);
        if (id) next.set("programId", id); else next.delete("programId");
        setSearchParams(next);
    };

    const archive = async (program) => {
        //old if (!window.confirm(`Archive "${program.ProgramName}"? Its ${program.EnrolledCount} enrollment(s) end and the invitation code stops working.`)) return;
        // a program has no invitation code any more (Alicia, Oct 30)
        if (!window.confirm(`Archive "${program.ProgramName}"? Its ${program.EnrolledCount} enrollment(s) end.`)) return;
        try {
            await api.delete(`/org/${orgId}/programs/${program.ProgramID}`);
            select(null);
            await Promise.all([load(), reloadOrg()]);
        } catch (err) {
            setError(apiError(err));
        }
    };

    const atLimit = org.ProgramCount >= org.ProgramLimit;
    // A new organization's only program is still the default one made for it ("Fiscal Year 2027", named by the
    // backend's cohort_service._default_program_dates): its admin is told what to do with it instead of the limit
    // (JJ, Nov 2). Renamed, it's theirs and the limit line shows as for any program; archived, there's no line.
    const defaultOnly = !loading && programs.length === 1 && /^Fiscal Year \d{4}$/.test(programs[0].ProgramName || "");
    const friendlyLimit = atLimit && defaultOnly && org.ProgramLimit === 1 && !isPlatformAdmin;

    if (selectedId) {
        return (
            <ProgramDashboard
                orgId={orgId}
                programId={selectedId}
                isOrgAdmin={isOrgAdmin}
                isPlatformAdmin={isPlatformAdmin}
                onBack={() => select(null)}
                onEdit={(p) => setEditing(p)}
                onArchive={archive}
                goTo={goTo}
                editor={editing && (
                    <ProgramForm orgId={orgId} program={editing} onClose={() => setEditing(null)}
                                 onSaved={async () => { setEditing(null); await load(); }} />
                )}
            />
        );
    }

    return (
        <>
            <Alert onClose={() => setError("")}>{error}</Alert>
            <Panel
                title="Programs"
                padded={false}
                actions={isOrgAdmin && (
                    <button type="button" className={s.btnPrimary} onClick={() => setEditing({})} disabled={atLimit}
                            //old title={atLimit ? `Program limit (${org.ProgramLimit}) reached` : undefined}>
                            title={!atLimit ? undefined : friendlyLimit ? `Your plan includes ${org.ProgramLimit} program` : `Program limit (${org.ProgramLimit}) reached`}>
                        <Plus size={16} /> New program
                    </button>
                )}
            >
                {/* old {isOrgAdmin && atLimit && ( */}
                {/* once the list is in, so the line that shows first is the one that stays */}
                {isOrgAdmin && atLimit && !loading && (
                    <p className={`px-5 pt-4 text-sm ${s.muted}`}>
                        {/* old You've reached your program limit ({org.ProgramLimit}). Archive a program or contact Pono Pilot to add more. */}
                        {/* a Pono Pilot admin raises the limit themselves */}
                        {isPlatformAdmin
                            ? <>This organization has reached its program limit ({org.ProgramLimit}). Raise it in <Link className={s.btnLink} to="/admin/organizations">Admin → Organizations</Link>.</>
                            // a new organization whose only program is still its default one (JJ, Nov 2)
                            : friendlyLimit
                                ? <>Your plan includes {org.ProgramLimit} program.{" "}
                                    <button type="button" className={s.btnLink} onClick={() => setEditing(programs[0])}>Edit {programs[0].ProgramName}</button>
                                    {" "}to make it yours, or{" "}
                                    <button type="button" className={s.btnLink} onClick={() => goTo("requests", { feature: "other" })}>send us a request</button> to add more.</>
                            //old : <>You've reached your program limit ({org.ProgramLimit}). Archive a program or contact Pono Pilot to add more.</>}
                            // (a higher limit is asked for on the Requests page)
                            : <>You've reached your program limit ({org.ProgramLimit}). Archive a program, or{" "}
                                <button type="button" className={s.btnLink} onClick={() => goTo("requests", { feature: "other" })}>send us a request</button> to add more.</>}
                    </p>
                )}
                {loading ? (
                    <div className="flex justify-center py-10"><Loader2 className={`animate-spin ${s.muted}`} /></div>
                ) : programs.length === 0 ? (
                    <EmptyState
                        icon={Layers}
                        title="No programs yet"
                        //old body="Programs group students and give them an invitation code to join. Students in a program can use its custom resume and interview criteria."
                        body="Programs group your clients. Clients in a program can use its custom resume and interview criteria."
                        action={isOrgAdmin && <button type="button" className={s.btnPrimary} onClick={() => setEditing({})}><Plus size={16} /> Create a program</button>}
                    />
                ) : (
                    <div className="relative overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className={`border-b ${s.dark ? "border-slate-700" : "border-slate-100"}`}>
                                    <th className={s.th}>Program</th>
                                    <th className={s.th}>Dates</th>
                                    {/* old <th className={s.th}>Students</th> */}
                                    <th className={s.th}>Clients</th>
                                    {/* old <th className={s.th}>Invitation code</th> */}
                                    <th className={s.th}><span className="sr-only">Actions</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {programs.map((p) => (
                                    <tr key={p.ProgramID} className={`border-b last:border-0 ${s.row}`}>
                                        <td className={s.td}>
                                            <button type="button" onClick={() => select(p.ProgramID)} className={`text-left font-semibold ${s.text} hover:underline`}>
                                                {p.ProgramName}
                                            </button>
                                            {p.Outcome && <div className={`mt-0.5 line-clamp-1 text-xs ${s.muted}`}>{p.Outcome}</div>}
                                        </td>
                                        <td className={`${s.td} whitespace-nowrap`}><ProgramDates program={p} /></td>
                                        {/* old <td className={`${s.td} tabular-nums`}>{p.EnrolledCount}</td> */}
                                        <td className={`${s.td} tabular-nums`}>
                                            {p.EnrolledCount}
                                            {/* uploaded to the roster, not joined yet */}
                                            {p.InvitedCount > 0 && <div className={`text-xs ${s.muted}`}>+ {p.InvitedCount} invited</div>}
                                        </td>
                                        {/* old <td className={s.td}><InviteCode code={p.InviteCode} expiresOn={p.InviteCodeExpiresOn} expired={!!p.InviteCodeExpired} /></td> */}
                                        <td className={`${s.td} text-right`}>
                                            <div className="flex justify-end gap-1">
                                                <button type="button" className={s.btnLink} onClick={() => select(p.ProgramID)}>View</button>
                                                {isOrgAdmin && (
                                                    <button type="button" className={`${s.btnLink} ml-3`} onClick={() => setEditing(p)}>Edit</button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Panel>
            {editing && (
                <ProgramForm orgId={orgId} program={editing} onClose={() => setEditing(null)}
                             onSaved={async (saved) => {
                                 setEditing(null);
                                 await Promise.all([load(), reloadOrg()]);
                                 if (saved && !editing.ProgramID) select(saved.ProgramID);
                             }} />
            )}
        </>
    );
}

function ProgramDates({ program }) {
    const s = useOrgStyles();
    if (!program.StartDate && !program.EndDate) return <span className={s.muted}>Ongoing</span>;
    return <>{formatDate(program.StartDate) || "…"} – {formatDate(program.EndDate) || "ongoing"}</>;
}

/** Shareable signup link for a program's invitation code (opens /join/<code>). */
export const inviteLink = (code) => `${window.location.origin}/join/${encodeURIComponent(code)}`;

//old /** Invitation links last 7, 30 or 90 days, or never expire (0) — same choices as the backend. */
//old const LINK_DAYS = [7, 30, 90, 0];
//old const linkDaysLabel = (d) => (d ? `${d} days` : "Never expires");
// (a program's invitation link is gone, Alicia, Oct 30; InviteCode and inviteLink above stay for license codes)

export function InviteCode({ code, expiresOn, expired, onRegenerate, regenerating }) {
    const s = useOrgStyles();
    const [copied, setCopied] = useState(""); // "" | "code" | "link"
    const copy = async (what) => {
        try {
            await navigator.clipboard.writeText(what === "link" ? inviteLink(code) : code);
            setCopied(what);
            setTimeout(() => setCopied(""), 1500);
        } catch { /* clipboard blocked: the code is still visible to copy by hand */ }
    };
    return (
        <span className="inline-flex items-center gap-1.5">
            <code className={`rounded-md px-2 py-1 font-mono text-sm font-semibold tracking-wider ${s.dark ? "bg-slate-700 text-slate-100" : "bg-slate-100 text-slate-800"}`}>{code}</code>
            <button type="button" onClick={() => copy("code")} aria-label={`Copy invitation code ${code}`} title="Copy code"
                    className={`rounded-md p-1.5 ${s.dark ? "hover:bg-slate-700" : "hover:bg-slate-100"}`}>
                {copied === "code" ? <Check size={14} className="text-emerald-500" /> : <Copy size={14} className={s.muted} />}
            </button>
            <button type="button" onClick={() => copy("link")} aria-label={`Copy invitation link for ${code}`} title="Copy invite link"
                    className={`rounded-md p-1.5 ${s.dark ? "hover:bg-slate-700" : "hover:bg-slate-100"}`}>
                {copied === "link" ? <Check size={14} className="text-emerald-500" /> : <Link2 size={14} className={s.muted} />}
            </button>
            {onRegenerate && (
                <button type="button" onClick={onRegenerate} disabled={regenerating} aria-label="Generate a new invitation code"
                        title="Generate a new code (the old one stops working)"
                        className={`rounded-md p-1.5 ${s.dark ? "hover:bg-slate-700" : "hover:bg-slate-100"}`}>
                    <RefreshCw size={14} className={`${s.muted} ${regenerating ? "animate-spin" : ""}`} />
                </button>
            )}
            {expired
                ? <Pill tone="warning">Expired</Pill>
                : expiresOn && <span className={`whitespace-nowrap text-xs ${s.muted}`}>until {formatDate(expiresOn)}</span>}
        </span>
    );
}

function ProgramForm({ orgId, program, onClose, onSaved }) {
    const s = useOrgStyles();
    const isNew = !program.ProgramID;
    const [form, setForm] = useState({
        programName: program.ProgramName || "",
        description: program.Description || "",
        startDate: program.StartDate ? String(program.StartDate).slice(0, 10) : "",
        endDate: program.EndDate ? String(program.EndDate).slice(0, 10) : "",
        outcome: program.Outcome || "",
        // no invitation code to set (Alicia, Oct 30): the backend makes one for every program, never shown
        //old inviteCode: "",
        //old inviteCodeDays: 30,
    });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError("");
        const payload = { ...form, startDate: form.startDate || null, endDate: form.endDate || null };
        //old if (!payload.inviteCode) delete payload.inviteCode;
        //old // Only a new program or a new code starts a new link expiry
        //old if (!isNew && !payload.inviteCode) delete payload.inviteCodeDays;
        try {
            const res = isNew
                ? await api.post(`/org/${orgId}/programs`, payload)
                : await api.put(`/org/${orgId}/programs/${program.ProgramID}`, payload);
            await onSaved(res.data.program);
        } catch (err) {
            setError(apiError(err));
            setSaving(false);
        }
    };

    return (
        <OrgModal
            isOpen
            onClose={onClose}
            title={isNew ? "New program" : "Edit program"}
            footer={<>
                <button type="button" className={s.btnSecondary} onClick={onClose}>Cancel</button>
                <button type="submit" form="program-form" className={s.btnPrimary} disabled={saving}>
                    {saving && <Loader2 size={14} className="animate-spin" />} {isNew ? "Create program" : "Save"}
                </button>
            </>}
        >
            <Alert>{error}</Alert>
            <form id="program-form" onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
                <Field label="Program name" htmlFor="pf-name" className="sm:col-span-2">
                    <input id="pf-name" className={s.input} value={form.programName} onChange={set("programName")} required maxLength={200} autoFocus />
                </Field>
                <Field label="Start date" htmlFor="pf-start">
                    <input id="pf-start" type="date" className={s.input} value={form.startDate} onChange={set("startDate")} />
                </Field>
                {/* old <Field label="End date" htmlFor="pf-end" hint="Students can't join after this date."> */}
                {/* the invitation code's rule: past this date a running or coming cohort still takes students (Pono Pilot runs them when they're hidden) */}
                <Field label="End date" htmlFor="pf-end"
                       //old hint={`After this date, students can still join while one of its cohorts is running or hasn't started yet.${program.HideCohorts ? " Pono Pilot runs its cohorts." : ""}`}>
                       // (no code to join a program since Oct 30, so the sentence about joining after this date went; the rest stays)
                       hint={program.HideCohorts ? "Pono Pilot runs its cohorts." : undefined}>
                    <input id="pf-end" type="date" className={s.input} value={form.endDate} min={form.startDate || undefined} onChange={set("endDate")} />
                </Field>
                {/* old <Field label="Outcome" htmlFor="pf-outcome" className="sm:col-span-2" hint="What students should achieve, e.g. “Land a summer internship”."> */}
                {/* Alicia's example (Oct 30) */}
                <Field label="Outcome" htmlFor="pf-outcome" className="sm:col-span-2" hint="What clients should achieve, e.g. “Get Hired, Get Promoted”.">
                    <input id="pf-outcome" className={s.input} value={form.outcome} onChange={set("outcome")} maxLength={1000} />
                </Field>
                <Field label="Description" htmlFor="pf-desc" className="sm:col-span-2">
                    <textarea id="pf-desc" rows={3} className={s.input} value={form.description} onChange={set("description")} maxLength={1000} />
                </Field>
                {/* no invitation code (Alicia, Oct 30: Remove Invitation Code from Program) */}
                {/* old <Field label={isNew ? "Invitation code (optional)" : "New invitation code (optional)"} htmlFor="pf-code" className="sm:col-span-2" */}
                {/* old        hint={isNew ? "Leave blank to generate one. 4–32 letters, numbers or dashes." : "Leave blank to keep the current code."}> */}
                {/* old     <input id="pf-code" className={`${s.input} font-mono uppercase`} value={form.inviteCode} */}
                {/* old            onChange={(e) => setForm((f) => ({ ...f, inviteCode: e.target.value.toUpperCase() }))} */}
                {/* old            pattern="[A-Za-z0-9-]{4,32}" maxLength={32} placeholder={program.InviteCode || "e.g. SPRING26"} /> */}
                {/* old </Field> */}
                {/* old {(isNew || form.inviteCode) && ( */}
                {/* old     <Field label="Invite link lasts" htmlFor="pf-days" hint="After that the code and link stop working; you can make a new one anytime."> */}
                {/* old         <select id="pf-days" className={s.input} value={form.inviteCodeDays} */}
                {/* old                 onChange={(e) => setForm((f) => ({ ...f, inviteCodeDays: Number(e.target.value) }))}> */}
                {/* old             {LINK_DAYS.map((d) => <option key={d} value={d}>{linkDaysLabel(d)}</option>)} */}
                {/* old         </select> */}
                {/* old     </Field> */}
                {/* old )} */}
            </form>
        </OrgModal>
    );
}

//old function ProgramDashboard({ orgId, programId, isOrgAdmin, onBack, onEdit, onArchive, goTo, editor }) {
function ProgramDashboard({ orgId, programId, isOrgAdmin, isPlatformAdmin, onBack, onEdit, onArchive, goTo, editor }) {
    const s = useOrgStyles();
    const [data, setData] = useState(null);
    const [error, setError] = useState("");
    //old const [regenerating, setRegenerating] = useState(false);

    const load = useCallback(async () => {
        try {
            const res = await api.get(`/org/${orgId}/programs/${programId}`);
            setData(res.data);
        } catch (err) {
            setError(apiError(err, "Couldn't load this program."));
        }
    }, [orgId, programId]);

    // Loads on mount and again whenever the edit modal closes.
    const editorOpen = !!editor;
    useEffect(() => { if (!editorOpen) load(); }, [editorOpen, load]);

    // (no invitation code, so no new link to make: Alicia, Oct 30)
    //old const [linkDays, setLinkDays] = useState(30);
    //old const regenerate = async () => {
    //old     if (!window.confirm(`Make a new invite link${linkDays ? ` that lasts ${linkDays} days` : " that never expires"}? The current code and link stop working immediately.`)) return;
    //old     setRegenerating(true);
    //old     try {
    //old         await api.post(`/org/${orgId}/programs/${programId}/invite-code`, { days: linkDays });
    //old         await load();
    //old     } catch (err) {
    //old         setError(apiError(err));
    //old     } finally {
    //old         setRegenerating(false);
    //old     }
    //old };

    if (!data) {
        return (
            <div>
                <button type="button" onClick={onBack} className={`mb-4 inline-flex items-center gap-1 ${s.btnLink}`}><ArrowLeft size={16} /> All programs</button>
                <Alert>{error}</Alert>
                {!error && <div className="flex justify-center py-10"><Loader2 className={`animate-spin ${s.muted}`} /></div>}
            </div>
        );
    }

    const { program, assessments, criteria, detailsAvailable } = data;
    return (
        <div className="space-y-6">
            <button type="button" onClick={onBack} className={`inline-flex items-center gap-1 ${s.btnLink}`}><ArrowLeft size={16} /> All programs</button>
            <Alert onClose={() => setError("")}>{error}</Alert>
            <Panel
                title={program.ProgramName}
                actions={isOrgAdmin && <>
                    <button type="button" className={s.btnSecondary} onClick={() => onEdit(program)}><Pencil size={14} /> Edit</button>
                    <button type="button" className={s.btnDanger} onClick={() => onArchive(program)}><Archive size={14} /> Archive</button>
                </>}
            >
                <div className="grid gap-5 md:grid-cols-3">
                    <div className="md:col-span-2 space-y-3">
                        {program.Outcome && <p className={s.body}><span className={`font-semibold ${s.text}`}>Outcome: </span>{program.Outcome}</p>}
                        {program.Description && <p className={`text-sm ${s.body}`}>{program.Description}</p>}
                        <p className={`text-sm ${s.muted}`}><ProgramDates program={program} /></p>
                    </div>
                    <div className={`rounded-xl border p-4 ${s.subPanel}`}>
                        {/* No invitation code to share (Alicia, Oct 30): the organization's admin puts clients in the program */}
                        {/* old <div className={`mb-2 text-xs font-semibold uppercase tracking-wide ${s.muted}`}>Invitation code</div> */}
                        {/* old <InviteCode code={program.InviteCode} expiresOn={program.InviteCodeExpiresOn} expired={!!program.InviteCodeExpired} /> */}
                        {/* old <p className={`mt-2 text-xs ${s.muted}`}>Share the invite link — new students sign up and join in one step. Existing students can also enter the code under My Coaching → Programs.</p> */}
                        {/* old {isOrgAdmin && ( */}
                        {/* old     <div className="mt-3 flex flex-wrap items-center gap-2 text-xs"> */}
                        {/* old         <label htmlFor="link-days" className={s.muted}>New link lasting</label> */}
                        {/* old         <select id="link-days" className={`${s.input} max-w-[7.5rem] py-1 text-xs`} value={linkDays} */}
                        {/* old                 onChange={(e) => setLinkDays(Number(e.target.value))}> */}
                        {/* old             {LINK_DAYS.map((d) => <option key={d} value={d}>{linkDaysLabel(d)}</option>)} */}
                        {/* old         </select> */}
                        {/* old         <button type="button" className={s.btnSm} onClick={regenerate} disabled={regenerating}> */}
                        {/* old             <RefreshCw size={12} className={regenerating ? "animate-spin" : ""} /> Make new link */}
                        {/* old         </button> */}
                        {/* old     </div> */}
                        {/* old )} */}
                        {/* old <button type="button" className={`mt-3 inline-flex items-center gap-1 ${s.btnLink}`} */}
                        <button type="button" className={`inline-flex items-center gap-1 ${s.btnLink}`}
                                onClick={() => goTo("students", { programId: String(program.ProgramID) })}>
                            {/* old <Users size={14} /> {program.EnrolledCount} student{program.EnrolledCount === 1 ? "" : "s"} enrolled */}
                            {/* old <Users size={14} /> {program.EnrolledCount} student{program.EnrolledCount === 1 ? "" : "s"} enrolled */}
                            <Users size={14} /> {program.EnrolledCount} client{program.EnrolledCount === 1 ? "" : "s"} enrolled
                            {program.InvitedCount > 0 ? `, ${program.InvitedCount} invited` : ""}
                        </button>
                        {/* how clients get in now, instead of the code (Alicia: rely on the Admin assigning clients) */}
                        {isOrgAdmin && <p className={`mt-2 text-xs ${s.muted}`}>Add clients to this program with Add client or Upload roster on the Clients page.</p>}
                    </div>
                </div>
            </Panel>

            {/* Cohorts and the program's suggestion list (Alicia, Oct 2) */}
            {/* old <ProgramCohorts orgId={orgId} programId={programId} programName={program.ProgramName} isOrgAdmin={isOrgAdmin} /> */}
            {/* Only Pono Pilot sees them when it hides this program's cohorts from the organization (Alicia, Oct 9) */}
            {(!program.HideCohorts || isPlatformAdmin) && (
                <ProgramCohorts orgId={orgId} programId={programId} programName={program.ProgramName} isOrgAdmin={isOrgAdmin}
                                isPlatformAdmin={isPlatformAdmin} cohortsHidden={!!program.HideCohorts} onHiddenChange={load} />
            )}
            {/* the organization keeps the program's own suggestion list and sends it to the whole program */}
            {!!program.HideCohorts && !isPlatformAdmin && (
                <ProgramSuggestions orgId={orgId} programId={programId} programName={program.ProgramName} isOrgAdmin={isOrgAdmin} />
            )}

            {/* The program's links for its students (Evan, Oct 9): not cohort data, so the org keeps them when cohorts are hidden */}
            <ProgramResources orgId={orgId} programId={programId} programName={program.ProgramName} isOrgAdmin={isOrgAdmin}
                              showCohorts={!program.HideCohorts || isPlatformAdmin} />

            <Panel title={<span className="inline-flex items-center gap-2"><ClipboardList size={18} /> Assessments</span>}>
                {assessments.length === 0 ? (
                    //old <p className={`text-sm ${s.muted}`}>No assessments are assigned to this program. Pono Pilot can add custom assessments and surveys for your organization or this program.</p>
                    <p className={`text-sm ${s.muted}`}>No assessments are assigned to this program. Pono Pilot can add custom assessments and surveys for your organization{!program.HideCohorts || isPlatformAdmin ? ", this program or one of its cohorts" : " or this program"}.</p>
                ) : (
                    <ul className={`divide-y ${s.divider}`}>
                        {assessments.map((a) => (
                            // Two cohorts of this program can have the same survey (Evan, Oct 9)
                            //old <li key={a.SurveyID} className="flex flex-wrap items-center justify-between gap-2 py-3">
                            <li key={a.SurveyAssignmentID} className="flex flex-wrap items-center justify-between gap-2 py-3">
                                <div>
                                    <div className={`font-semibold ${s.text}`}>{a.Title}</div>
                                    {a.Description && <div className={`text-sm ${s.muted}`}>{a.Description}</div>}
                                </div>
                                {/* old <div className="flex items-center gap-2"> */}
                                <div className="flex flex-wrap items-center gap-2">
                                    {/* old <Pill>{a.Scope === "program" ? "This program" : "Whole organization"}</Pill> */}
                                    {/* A cohort's assessment: its name (it may be long, so it wraps), or "Some students" when the program hides its cohorts */}
                                    {/* old <Pill>{a.Scope === "cohort" ? (a.CohortName ? <span className="whitespace-normal break-words">Only {a.CohortName}</span> : "Some students") : a.Scope === "program" ? "This program" : "Whole organization"}</Pill> */}
                                    <Pill>{a.Scope === "cohort" ? (a.CohortName ? <span className="whitespace-normal break-words">Only {a.CohortName}</span> : "Some clients") : a.Scope === "program" ? "This program" : "Whole organization"}</Pill>
                                    {detailsAvailable && (
                                        // A cohort's out of its students, with no total when the program hides its cohorts
                                        //old <Pill tone="primary">{a.CompletedCount} / {program.EnrolledCount} completed</Pill>
                                        <Pill tone="primary">{a.CompletedCount}{a.Scope !== "cohort" ? ` / ${program.EnrolledCount}` : a.CohortStudentCount != null ? ` / ${a.CohortStudentCount}` : ""} completed</Pill>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </Panel>

            <div className="grid gap-6 lg:grid-cols-2">
                <CriteriaPanel icon={FileText} title="Resume evaluation criteria" criteria={criteria.resume} />
                <CriteriaPanel icon={Mic} title="Interview evaluation criteria" criteria={criteria.interview} />
            </div>
            {editor}
        </div>
    );
}

// The program's links. Cohorts without their own copy use them; a cohort's copy is
// edited in its window (ProgramCohorts). showCohorts is false for the org when the
// program hides its cohorts.
function ProgramResources({ orgId, programId, programName, isOrgAdmin, showCohorts }) {
    const s = useOrgStyles();
    const [resources, setResources] = useState(null);
    const [error, setError] = useState("");
    const [editing, setEditing] = useState(false);
    // a cohort hidden from the org has its own links, so some students see those instead
    const [othersSeeOtherLinks, setOthersSeeOtherLinks] = useState(false);

    const load = useCallback(async () => {
        try {
            const res = await api.get(`/org/${orgId}/programs/${programId}/resources`);
            setResources(res.data.resources || []);
            setOthersSeeOtherLinks(!!res.data.someStudentsSeeOtherLinks);
        } catch (err) {
            setError(apiError(err, "Couldn't load this program's resources."));
        }
    }, [orgId, programId]);

    useEffect(() => { load(); }, [load]);

    const save = async (items) => {
        const res = await api.put(`/org/${orgId}/programs/${programId}/resources`, { resources: items });
        setResources(res.data.resources || []);
        setEditing(false);
    };

    const title = <span className="inline-flex items-center gap-2"><BookOpen size={18} /> Resources for this program</span>;
    if (!resources) {
        return (
            <Panel title={title}>
                <Alert>{error}</Alert>
                {!error && <InlineTableSkeleton isDarkMode={s.dark} rows={2} cols={1} bordered={false} />}
            </Panel>
        );
    }

    return (
        <>
            <Panel
                title={title}
                actions={isOrgAdmin && (
                    <button type="button" className={s.btnSecondary} onClick={() => setEditing(true)}>
                        {resources.length ? <><Pencil size={14} /> Edit list</> : <><Plus size={14} /> Add resources</>}
                    </button>
                )}
            >
                <p className={`mb-4 text-sm ${s.muted}`}>
                    {showCohorts
                        //old ? "Links every cohort's students see in My Coaching → Programs, unless a cohort has its own list."
                        ? "Links every cohort's clients see in My Coaching → Programs, unless a cohort has its own list."
                        //old : "Links students in this program see in My Coaching → Programs."}
                        : othersSeeOtherLinks
                            //old ? "Links students in this program see in My Coaching → Programs. Some students see a different list Pono Pilot set up for them."
                            ? "Links clients in this program see in My Coaching → Programs. Some clients see a different list Pono Pilot set up for them."
                            //old : "Links students in this program see in My Coaching → Programs."}
                            : "Links clients in this program see in My Coaching → Programs."}
                </p>
                <ResourceList items={resources}
                              //old empty={`No resources yet.${isOrgAdmin ? " Add links students in this program should have, like your career center." : ""}`} />
                              empty={`No resources yet.${isOrgAdmin ? " Add links clients in this program should have, like your career center." : ""}`} />
            </Panel>
            {editing && (
                <ResourceEditor
                    title={`Resources for ${programName}`}
                    hint={showCohorts
                        //old ? "Every cohort uses this list unless it has its own. Students see changes the next time they open their Programs page."
                        ? "Every cohort uses this list unless it has its own. Clients see changes the next time they open their Programs page."
                        //old : "Students see changes the next time they open their Programs page."}
                        : "Clients see changes the next time they open their Programs page."}
                    initial={resources}
                    allowEmpty
                    onSave={save}
                    onClose={() => setEditing(false)}
                />
            )}
        </>
    );
}

const SCOPE_LABEL = { program: "Custom for this program", organization: "Custom for your organization", default: "Pono Pilot default" };

function CriteriaPanel({ icon: Icon, title, criteria }) {
    const s = useOrgStyles();
    return (
        <Panel title={<span className="inline-flex items-center gap-2"><Icon size={18} /> {title}</span>}
               actions={<Pill tone={criteria.Scope === "default" ? "neutral" : "primary"}>{SCOPE_LABEL[criteria.Scope]}</Pill>}>
            {criteria.Scope !== "default" && <p className={`mb-3 text-sm font-semibold ${s.text}`}>{criteria.Name}</p>}
            {criteria.Description && <p className={`mb-3 text-sm ${s.body}`}>{criteria.Description}</p>}
            <ul className="space-y-2">
                {(criteria.categories || []).map((c) => (
                    <li key={c.Name}>
                        <div className="flex items-center justify-between gap-3 text-sm">
                            <span className={`font-medium ${s.text}`}>{c.Name}</span>
                            <span className={`tabular-nums ${s.muted}`}>{c.Weight}%</span>
                        </div>
                        <div className={`mt-1 h-1.5 overflow-hidden rounded-full ${s.dark ? "bg-slate-700" : "bg-slate-100"}`}>
                            <div className="h-full rounded-full bg-primary-500" style={{ width: `${Math.min(100, c.Weight)}%` }} />
                        </div>
                        {c.Description && <p className={`mt-1 text-xs ${s.muted}`}>{c.Description}</p>}
                    </li>
                ))}
            </ul>
            {criteria.AdditionalInstructions && (
                <p className={`mt-4 rounded-lg border p-3 text-xs ${s.subPanel} ${s.body}`}>
                    <span className="font-semibold">Additional guidance: </span>{criteria.AdditionalInstructions}
                </p>
            )}
        </Panel>
    );
}
